import React, { useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { GlobeIcon, MoonIcon, SunIcon, CheckIcon } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';
import { useLocale } from '../../contexts/LocaleContext';
import { locales } from '../../data/locales';
import { IconButton } from '../ui/Button';
import { spring } from '../../utils/motion';
import { cn } from '../../utils/cn';
export function PrefsMenu({
  compact = false,
  showLocale = true
}: {
  compact?: boolean;
  showLocale?: boolean;
}) {
  const {
    theme,
    toggle
  } = useTheme();
  const {
    locale,
    setLocale,
    t
  } = useLocale();
  const [open, setOpen] = useState(false);
  const reduce = useReducedMotion();
  const current = locales.find(l => l.code === locale) ?? locales[0];
  return <div className="flex items-center gap-2" data-id="element-841" data-mp="2p2c5fzhwkkz8">
      <div className={cn('relative', !showLocale && 'hidden')} data-id="element-842" data-mp="2p33railp74cb">
        <IconButton label={`Language — ${current.english}`} onClick={() => setOpen(o => !o)} className={cn(compact && 'h-9 w-9')} data-id="element-843" data-mp="2k9siwd18mfia">
          <GlobeIcon style={{
          height: 18,
          width: 18
        }} aria-hidden="true" data-id="element-844" data-mp="169gydwo8c3k9" />
        </IconButton>
        <AnimatePresence data-id="element-845" data-mp="sic316rw9xfq">
          {open && <>
              <button type="button" aria-label="Close language menu" className="fixed inset-0 z-40 cursor-default" onClick={() => setOpen(false)} data-id="element-846" data-mp="sfzol3lci57f" />
              <motion.ul initial={reduce ? {
            opacity: 0
          } : {
            opacity: 0,
            y: -6,
            scale: 0.98
          }} animate={reduce ? {
            opacity: 1
          } : {
            opacity: 1,
            y: 0,
            scale: 1
          }} exit={reduce ? {
            opacity: 0
          } : {
            opacity: 0,
            y: -4,
            scale: 0.99
          }} transition={reduce ? {
            duration: 0.13
          } : spring.snappy} className="absolute right-0 z-50 mt-2 w-52 overflow-hidden rounded-xl border border-hairline bg-surface py-1.5 shadow-float" data-id="element-847" data-mp="iil9b7b5rmgp">
                {locales.map(l => <li key={l.code} data-id="element-848" data-mp="27w89v1uwsdvy">
                    <button type="button" onClick={() => {
                setLocale(l.code);
                setOpen(false);
              }} className="flex w-full items-center justify-between px-3.5 py-2 text-left text-sm text-ink transition-colors duration-150 ease-out hover:bg-oat" data-id="element-849" data-mp="3gvrjqgxx6h66">
                      <span data-id="element-850" data-mp="3guykirit1ho">
                        {l.label}
                        <span className="ml-2 text-xs text-ink-3" data-id="element-851" data-mp="3vkdzgjrglaxx">{l.english}</span>
                      </span>
                      {l.code === locale && <CheckIcon className="h-4 w-4 text-primary" aria-hidden="true" data-id="element-852" data-mp="3qsvwxr9sf2au" />}
                    </button>
                  </li>)}
              </motion.ul>
            </>}
        </AnimatePresence>
      </div>
      <IconButton label={theme === 'light' ? t('theme.dark') : t('theme.light')} onClick={toggle} className={cn(compact && 'h-9 w-9')} data-id="element-853" data-mp="n5x2y9askp6p">
        {theme === 'light' ? <MoonIcon style={{
        height: 18,
        width: 18
      }} aria-hidden="true" data-id="element-854" data-mp="pr4rbc2baehn" /> : <SunIcon style={{
        height: 18,
        width: 18
      }} aria-hidden="true" data-id="element-855" data-mp="uodbfi70sslj" />}
      </IconButton>
    </div>;
}